import HTTP from '@/api/HTTP';

const URL_BASE = 'gescom/DevisCommandeFacture/';

export default async function PGetTotalMntFacturerBrouillonAFacturer(params) {
  const response = await HTTP.post(URL_BASE + 'PGetTotalMntFacturerBrouillonAFacturerAsync', params);
  return response;
}

export function EditAllCommercial(payload) {
  return HTTP.put(URL_BASE + 'UpdateAllCommercialAsync', payload);
}
